import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { VENDOR_BALANCE_API } from "./apiRoutes";
import { FieldValues } from "react-hook-form";

interface UseGetVendorBalanceReportProps {
  data: FieldValues;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getVendorBalanceReport = async (data: FieldValues) =>
  await axiosAuth.post(`${VENDOR_BALANCE_API(data?.communityId)}`, data);

const useGetVendorBalanceReport = ({
  data,
  queryParams,
}: UseGetVendorBalanceReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["vendor-balance-report", data?.communityId],
    queryFn: () => getVendorBalanceReport(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetVendorBalanceReport;
